import { Button } from '@onchainstudios/cryptoys-common-ui';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { deleteReservation } from '../../lib/cryptoys/drops/reservation';
import { useQueryClient } from '@tanstack/react-query';
import StatusPage from '../../components/StatusPage';
import { getLegionImage, resetReservation } from '../../utils';
import CometZiggy from '../../img/zoo/CometZiggy.webp';

function TimeExpired() {
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Cancel the current reservation to make inventory available
    const id = searchParams.get('reservationId');
    if (id) {
      deleteReservation(id, searchParams.get('correlationId'));
    }
    //  We only want this to run once after the page loads
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = 'Cryptoys - Time to purchase expired';
  }, []);

  const clearQueries = async () => {
    await queryClient.invalidateQueries();
  };

  return (
    <>
      <StatusPage
        waveColor="yellow"
        legionImage={getLegionImage('timeExpired') ?? CometZiggy}
        contentHeading="Time Ran Out!"
        contentHeadingTag={
          <span>
            {!!searchParams.get('timeoutErrorMessage')
              ? decodeURIComponent(searchParams.get('timeoutErrorMessage'))
              : 'You ran out of time to check out, but if you hurry you might still be able to purchase a Cryptoys Cube!'}
          </span>
        }
        buttonCont={
          <Button
            id="buyNowButton"
            data-testid="restart-button"
            size="large"
            onPress={async () => {
              await clearQueries();
              resetReservation(searchParams.get('dropId'));
            }}
          >
            Try Again
          </Button>
        }
      />
    </>
  );
}

export default TimeExpired;
